<!--
 * @Author: your name
 * @Date: 2021-09-14 14:24:21
 * @LastEditTime: 2024-03-08 15:28:18
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\review\children\ProgramPreview.vue
-->
<template>
  <div class="program-preview flex-b-c">
    <div class="w-list">
      <window-list></window-list>
    </div>
    <div class="vdr-box flex-c-c" id="programPreview">
      <vdr></vdr>
    </div>

  </div>
</template>

<script>
import superClone from '@/assets/scripts/superClone.js'
import { dataFlattening } from '@/assets/scripts/programData.js'
import { hexToRgba } from '@/assets/scripts/rgbaAndHex.js'
import vdr from '@/components/schedule/windows/children/Vdr'
import toolsList from '@/assets/scripts/toolsList.js';
import WindowList from '@/components/schedule/windows/children/WindowList'

export default {
  name: "ProgramPreview",
  provide() {
    return {
      vdrInfor: this.screenParam
    }
  },
  props: {
    screenParam: {
      type: Object,
      default: () => { }
    },
    vdrList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      vdrInfor: superClone(this.screenParam),
      toolsList: toolsList(),
    }
  },
  mounted() {
    this.$nextTick(() => {
      let vdrWindow = document.getElementById("programPreview");
      let vdrWindowW = vdrWindow.offsetWidth;
      let vdrWindowH = vdrWindow.offsetHeight;
      let vdrw = this.vdrInfor.w;
      let vdrh = this.vdrInfor.h;
      let ratioH = (vdrWindowH * 1) / vdrh;
      let ratioW = (vdrWindowW * 1) / vdrw;
      let ratio = ratioH < ratioW ? ratioH : ratioW;
      this.ratioEdit(ratio);
    });
    this.$nextTick(() => {
      this.vdrInit(superClone(this.vdrList));
    });
    // 工具图标初始化
    this.toolsList.forEach((tool) => {
      tool.image && (tool.image = require("@/assets/images/program/" + tool.image));
    });
  },
  methods: {
    ratioEdit(args) {
      this.$store.commit("RATIO_COUNT", args);
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },
    vdrInit(vdrList) {
      // 清空所有节目编辑数据
      this.$store.commit("VDR_LIST_CLEAR");
      vdrList.forEach((vdrItem) => {
        vdrItem.wicket.forEach((wicketItem, index) => {
          vdrItem.wicket[index] = this.wicketInit(dataFlattening(wicketItem));
        });
        this.$store.commit("VDR_LIST_ADD", vdrItem);
      });
    },
    // 数据解析
    wicketInit(wicket) {
      // 初始化播放时长
      wicket.ext_val_duration = parseInt(wicket.ext_val_duration / 1000);
      // 进入时间初始化
      if (wicket.ext_val_enterTime !== undefined) {
        wicket.ext_val_enterTime = parseInt(wicket.ext_val_enterTime / 1000);
      }
      // 时间格式化
      if (wicket.type === '12' || wicket.type === '13') {
        wicket.ext_val_absoluteTime = new Date(wicket.ext_val_absoluteTime * 1000);
      }
      // 初始化颜色设置
      for (let key in wicket) {
        if (/Color?$/.test(key)) {
          wicket[key] = hexToRgba(wicket[key]);
        }
      }
      // 保持比例格式化
      if (wicket.ext_val_scaleType !== undefined) {
        wicket.ext_val_scaleType = wicket.ext_val_scaleType === 1 ? false : true;
      }
      // 初始化工具图标
      let isUpPimg = { '1': true, '2': true, }
      if (!isUpPimg[wicket.type]) {
        let tool = this.toolsList.find((tool) => tool.type === wicket.type);
        wicket.ext_val_pimg = tool.image
      }
      // console.log(wicket);
      return wicket;
    },
  },
  components: {
    vdr,
    WindowList
  }
}
</script>

<style lang="scss" scoped>
.program-preview {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  .w-list {
    width: 244px;
    height: 100%;
    border-right: 1px solid #d7ecf3;
  }
  .vdr-box {
    width: calc(100% - 46px - 244px);
    height: 100%;
    // 抵消外边框
    margin: 0px 16px;
  }
}
</style>